import React from 'react';

function CalendarItem({
  day,
  disabled,
  allPeriodesDisabled,
  selectedDay,
  onCalendarItemClick,
}) {
  const getItemStyle = () => {
    if (disabled) {
      return 'border-gray text-gray';
    } else if (allPeriodesDisabled) {
      return 'bg-secondary text-white hover:bg-black cursor-pointer'
    }else if (selectedDay === day) {
      return 'bg-primary text-white hover:bg-primaryDark cursor-pointer';
    }
    return 'text-primary border-primary hover:text-white hover:bg-primary cursor-pointer';
  };

  return (
    <div
      className={`border-2 ${getItemStyle()} rounded-[20px] flex justify-center items-center text-3xl font-medium h-[70px] w-[70px]`}
      onClick={onCalendarItemClick}
    >
      {day}
    </div>
  );
}

export default function Calendar({
  numberOfDays,
  disabledList,
  desactivatedDates,
  selectedDay,
  setSelectedDay,
  isError,
  error
}) {
  const generateRange = (n) => {
    const result = [];
    for (let i = 1; i <= n; i++) {
      result.push(i);
    }
    return result;
  };

  const numberExistsInList = (number, list) => {
    return list.includes(number);
  };

  return (
    <div className={`w-[400px] sm:w-[600px] ${isError && 'border-2 border-primary rounded-[20px]'}`}>
      <div className='grid grid-cols-5 sm:grid-cols-8 gap-2 w-full'>
        {generateRange(numberOfDays).map((n) => {
          return (
            <CalendarItem
              key={n}
              day={n}
              disabled={numberExistsInList(n, disabledList)}
              allPeriodesDisabled={numberExistsInList(n, desactivatedDates)}
              selectedDay={selectedDay}
              onCalendarItemClick={() => {
                if (!numberExistsInList(n, disabledList)) {
                  setSelectedDay(n);
                }
              }}
            />
          );
        })}
      </div>
      <p className={`relative pl-5 font-medium text-xl text-primary ${isError ? 'block' : 'hidden'}`}>{error}</p>
    </div>
  );
}
